// extracted by mini-css-extract-plugin
export default {"container":"css-sync_container__DXf1f","truncate-table":"css-sync_truncate-table__b+Rja","table-text-faded":"css-sync_table-text-faded__quhnK","css":"css-sync_css__Ola6a","topBar":"css-sync_topBar__PFDZn","topBarContainer":"css-sync_topBarContainer__WEwpW","topBarLeft":"css-sync_topBarLeft__6r4vV","details":"css-sync_details__sYuSv","alert":"css-sync_alert__btze8"};
    if(module.hot) {
      // 1793877077153
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  